import React from "react";
import "./luckify.scss";
const Luckify = () => {
  return (
    <>
      <section className="luckifymain">
        <div className="custom-container">
          <div className="luckifyinner">
                    {window.innerWidth < 991 ? 
            <img
              src="/assets/luckifymainimgmbl.png"
              alt="luckifybg"
              className="luckifybg"
            />
            :
                   <img
              src="/assets/luckifymainimg.png"
              alt="luckifybg"
              className="luckifybg"
            />
                    }
            <h1 className="luckifyhead">
              Luckify Isn’t Just a Game — It’s a Movement
            </h1>
            <p className="luckifypara">
              We’re not building just a casino or a game. We’re creating the
              trust layer for Web3 gaming. Every outcome. Every prize. Every
              draw — 100% provable.
            </p>
            <div className="luckifybtns">
              <a
                href="https://app.luckify.co/"
                target="_blank"
                className="launchbtn"
              >
                LAUNCH APP
              </a>
              <a href="/lightpaper.pdf" target="_blank" className="lightbtn">Lightpaper</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Luckify;
